<template>
  <div class="navbar">
    <div class="navbar__left">
      <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
      <breadcrumb></breadcrumb>
    </div>
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <div class="user-meta">
          <span class="user-name">{{ displayName }}</span>
          <span class="user-role">{{ roleLabel }}</span>
        </div>
        <img class="user-avatar" :src="avatar">
        <i class="el-icon-arrow-down"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <el-dropdown-item>
          <span style="display:block;" @click="openProfileDialog">修改资料</span>
        </el-dropdown-item>
        <el-dropdown-item divided>
          <span @click="changePass" style="display:block;">修改密码</span>
        </el-dropdown-item>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog title="修改资料" :visible.sync="profileVisible" width="45%">
      <el-form :model="profileForm" label-width="80px">
        <el-form-item label="头像">
          <div class="avatar-upload-wrapper">
            <div v-if="profileForm.imgUrl" class="avatar-preview">
              <img :src="profileForm.imgUrl" alt="头像预览">
              <div class="avatar-mask">
                <el-button size="small" type="primary" @click="triggerAvatarUpload">更换头像</el-button>
              </div>
            </div>
            <div v-else class="avatar-upload-placeholder" @click="triggerAvatarUpload">
              <i class="el-icon-plus"></i>
              <div class="upload-tip">点击上传头像</div>
            </div>
            <el-upload ref="avatarUpload" :action="uploadUrl" :headers="uploadHeaders" :show-file-list="false"
              :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess" :on-error="handleAvatarError"
              accept="image/jpeg,image/jpg,image/png" style="display: none;">
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="profileForm.name" placeholder="请输入昵称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="profileVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitProfile">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改密码" :visible.sync="passwordVisible" width="45%">
      <el-form ref="passwordForm" :model="passwordForm" :rules="rules" label-width="100px">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input type="password" class="handle-input" v-model="passwordForm.oldPassword"
            placeholder="旧密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input type="password" class="handle-input" v-model="passwordForm.password" placeholder="新密码"></el-input>
        </el-form-item>
        <el-form-item label="重复新密码" prop="repassword">
          <el-input type="password" class="handle-input" v-model="passwordForm.repassword"
            placeholder="重复新密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passwordVisible = false">取 消</el-button>
        <el-button type="primary" @click="savePassword('passwordForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { updateMyPassword } from '@/api/adminUser'
import { updateWorkerAvatar, updateWorkerName } from '@/api/workers'
import { getToken } from '@/utils/auth'
import { getCookie } from "@/utils/support";

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.passwordForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      userType: null,
      name: null,
      cityName: null,
      countyName: null,
      profileVisible: false,
      profileOriginAvatar: '',
      profileForm: {
        imgUrl: '',
        name: ''
      },
      uploadUrl: process.env.BASE_API + '/file/upload',
      passwordVisible: false,
      passwordForm: {
        oldPassword: "",
        password: "",
        repassword: ""
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
        ],
        repassword: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ]),
    uploadHeaders() {
      return {
        Authorization: getToken()
      }
    },
    displayName() {
      if (this.userType == 3) return '云朵极速总后台'
      if (this.userType == 1) return this.cityName || '城市经销商'
      if (this.userType == 2) return this.countyName || '区县经销商'
      if (this.userType == 0) return this.name || '送电掌柜'
      return this.name || '管理员'
    },
    roleLabel() {
      if (this.userType == 3) return '总后台'
      if (this.userType == 1) return '城市经销商'
      if (this.userType == 2) return '区县经销商'
      if (this.userType == 0) return '送电掌柜'
      return '管理后台'
    }
  },
  mounted() {
    this.userType = getCookie("userType");
    this.name = getCookie("name");
    this.cityName = getCookie("cityName");
    this.countyName = getCookie("countyName");
  },
  methods: {
    openProfileDialog() {
      this.profileForm.imgUrl = this.avatar
      this.profileForm.name = this.$store.getters.name || ''
      this.profileOriginAvatar = this.avatar
      this.profileVisible = true
    },
    triggerAvatarUpload() {
      this.$refs.avatarUpload.$el.querySelector('input').click()
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
        return false
      }
      if (!isLt10M) {
        this.$message.error('上传头像图片大小不能超过 10MB!')
        return false
      }
      return true
    },
    async handleAvatarSuccess(res) {
      if (res.code === 1000 && res.data) {
        const imgUrl = res.data
        this.profileForm.imgUrl = imgUrl
        try {
          await updateWorkerAvatar(imgUrl)
          this.profileOriginAvatar = imgUrl
          this.$store.commit('SET_AVATAR', imgUrl)
          this.$message({
            message: '头像修改成功',
            type: 'success',
            duration: 1000
          })
        } catch (e) {
          // 错误由拦截器统一处理
        }
      } else {
        this.$message.error(res.message || '上传失败')
      }
    },
    handleAvatarError() {
      this.$message.error('头像上传失败，请重试')
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload()
      })
    },
    async submitProfile() {
      try {
        if (this.profileForm.imgUrl && this.profileForm.imgUrl !== this.profileOriginAvatar) {
          await updateWorkerAvatar(this.profileForm.imgUrl)
          this.profileOriginAvatar = this.profileForm.imgUrl
          this.$store.commit('SET_AVATAR', this.profileForm.imgUrl)
        }
        if (this.profileForm.name) {
          await updateWorkerName(this.profileForm.name)
          this.$store.commit('SET_NAME', this.profileForm.name)
        }
        this.$message({
          message: '资料修改成功',
          type: 'success',
          duration: 1000
        })
        this.profileVisible = false
      } catch (e) {
        // 错误信息由拦截器统一处理
      }
    },
    changePass() {
      this.passwordVisible = true;
    },
    savePassword(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm('是否提交数据', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            updateMyPassword(this.passwordForm).then(response => {
              this.$refs[formName].resetFields();
              this.$message({
                message: '修改成功',
                type: 'success',
                duration: 1000
              });
              this.passwordVisible = false;
            });
          });
        } else {
          this.$message({
            message: '验证失败',
            type: 'error',
            duration: 1000
          });
          return false;
        }
      });
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px 0 8px;
  background: #fff;
  border-bottom: 1px solid #e8edf3;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.03);
}

.navbar__left {
  display: flex;
  align-items: center;
  min-width: 0;
}

.hamburger-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 12px;
  cursor: pointer;
  border-radius: 8px;

  &:hover {
    background: #f1f5f9;
  }
}

.avatar-container {
  .avatar-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 4px 6px 10px;
    cursor: pointer;
    border-radius: 12px;
    transition: background 180ms ease;

    &:hover {
      background: #f8fafc;
    }
  }

  .user-meta {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    line-height: 1.2;
  }

  .user-name {
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    font-weight: 600;
    color: #0f172a;
  }

  .user-role {
    margin-top: 3px;
    font-size: 11px;
    color: #64748b;
  }

  .user-avatar {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    object-fit: cover;
    background: #e2e8f0;
  }

  .el-icon-arrow-down {
    font-size: 12px;
    color: #94a3b8;
  }
}

.avatar-upload-wrapper {
  .avatar-preview {
    position: relative;
    width: 120px;
    height: 120px;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    overflow: hidden;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .avatar-mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.3s;
    }

    &:hover .avatar-mask {
      opacity: 1;
    }
  }

  .avatar-upload-placeholder {
    width: 120px;
    height: 120px;
    border: 1px dashed #dcdfe6;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: border-color 0.3s;

    &:hover {
      border-color: #409eff;
    }

    .el-icon-plus {
      font-size: 28px;
      color: #8c939d;
      margin-bottom: 8px;
    }

    .upload-tip {
      font-size: 12px;
      color: #8c939d;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue